import { useMemo } from 'react';
import { useInfiniteQuery } from '@tanstack/react-query';
import { reportsService } from '../services/api';
import { PaymentMethod, PaymentStatus, PaymentsReportResult } from '../types/reports';

export interface UsePaymentsReportFilters {
  startDate?: string;
  endDate?: string;
  status?: PaymentStatus[];
  paymentMethod?: Exclude<PaymentMethod, null>[];
  pedidoId?: string;
  providerPaymentId?: string;
  consumerId?: string;
  minAmount?: number;
  maxAmount?: number;
  limit?: number;
  cnpj?: string;
}

export const usePaymentsReport = (filters: UsePaymentsReportFilters, enabled = true) => {
  const queryParams = useMemo(
    () => ({
      startDate: filters.startDate,
      endDate: filters.endDate,
      status: filters.status,
      paymentMethod: filters.paymentMethod?.filter((method): method is Exclude<PaymentMethod, null> => method != null),
      pedidoId: filters.pedidoId,
      providerPaymentId: filters.providerPaymentId,
      consumerId: filters.consumerId,
      minAmount: filters.minAmount,
      maxAmount: filters.maxAmount,
      limit: filters.limit,
      cnpj: filters.cnpj,
    }),
    [filters],
  );

  return useInfiniteQuery<PaymentsReportResult, Error>({
    queryKey: ['payments-report', queryParams],
    queryFn: ({ pageParam }) =>
      reportsService.getPaymentsReport({
        ...queryParams,
        lastEvaluatedKey: (pageParam as Record<string, unknown> | undefined) ?? undefined,
      }),
    enabled,
    initialPageParam: undefined,
    getNextPageParam: (lastPage) => lastPage.pagination.lastEvaluatedKey ?? undefined,
    staleTime: 1000 * 60 * 2,
  });
};
